@include component-spacing-and-grid;

:host {
    display: block;
    scroll-margin-top: var(--header-height-scrolled);

    h2 {
        @include typo-ws-h2;

        margin: 0 0 40px;
    }

    ::slotted(sew-ws-richtext) {
        margin: -24px 0 60px;
    }

    slot[name='teaser-item'] {
        column-gap: var(--column-gap);
        display: grid;
        grid-template-columns: repeat(var(--columns), 1fr);
        row-gap: 40px;
    }

    .download {
        align-items: center;
        border-top: 2px solid $color-grey-01-dark;
        display: flex;
        margin-top: 80px;
        padding-top: 40px;
    }

    ::slotted(sew-ws-link) {
        margin-left: 40px;
    }

    .limit-content-width {
        display: grid;
        grid-template-columns: repeat(12, 1fr);

        > div {
            grid-column: span 8;
        }

        @include mq-2 {
            > div {
                grid-column: span 12;
            }
        }
    }
}

::slotted(*) {
    hyphens: auto;
}

@include mq-2-5 {
    :host {
        slot[name='teaser-item'] {
            grid-template-columns: 1fr 1fr 1fr;
        }
    }

    :host([columns='2']) {
        slot[name='teaser-item'] {
            grid-template-columns: 1fr 1fr;
        }
    }
}

@include mq-2 {
    :host {
        slot[name='teaser-item'] {
            grid-template-columns: 1fr 1fr;
        }
    }
}

@include mq-1 {
    :host {
        h2 {
            margin-bottom: 32px;
        }

        slot[name='teaser-item'] {
            display: grid;
            grid-template-columns: 1fr !important;
            row-gap: 60px;
        }

        .download {
            align-items: flex-start;
            flex-direction: column;
            margin-top: 60px;
            padding-top: 40px;
        }

        ::slotted(sew-ws-link) {
            margin-left: 0;
            margin-top: 32px;
        }
    }
}

@media print {
    :host {
        h2 {
            margin: 0 0 20px;
        }

        slot[name='teaser-item'] {
            display: flex;
            flex-direction: column;
            gap: 12px;
        }

        .download {
            margin-top: 60px;
            padding-top: 0;
        }
    }

    ::slotted([slot='download']) {
        display: none !important;
    }
}
